import angular from 'angular';
import uiRouter from 'angular-ui-router';
import aboutComponent from './about.component';

let aboutModule = angular
  .module('about', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('about', {
      url: '/about',
      component: 'about'
    });
  })
  .component('about', aboutComponent).name;

export default aboutModule;



// WEBPACK FOOTER //
// ./client/app/components/about/about.js